const AuthBase = () => {
  let domain = window.location.hostname
  let indexOfDomainStart = domain.indexOf('.')
  if (domain !== 'localhost') {
    if (domain.split('.').length == 3) {
      return (
        window.location.protocol +
        '//auth' +
        domain.substring(indexOfDomainStart) +
        '/api/v1/'
      )
    }
    if (domain.split('.').length == 2) {
      return window.location.protocol + '//auth.' + domain + '/api/v1/'
    }
  } else {
    return process.env.VUE_APP_AUTH_URL
  }
}

const BaseV2 = () => {
  let domain = window.location.hostname
  let indexOfDomainStart = domain.indexOf('.')
  if (domain !== 'localhost') {
    if (domain.split('.').length == 3) {
      return (
        window.location.protocol +
        '//cad-api' +
        domain.substring(indexOfDomainStart) +
        '/api/v2/'
      )
    }
    if (domain.split('.').length == 2) {
      return window.location.protocol + '//cad-api.' + domain + '/api/v2/'
    }
  } else {
    return process.env.VUE_APP_API_V2_URL
  }
}

const ApiBase = () => {
  let domain = window.location.hostname
  let indexOfDomainStart = domain.indexOf('.')
  if (domain !== 'localhost') {
    if (domain.split('.').length == 3) {
      return (
        window.location.protocol +
        '//cad-api' +
        domain.substring(indexOfDomainStart) +
        '/api/v1/'
      )
    }
    if (domain.split('.').length == 2) {
      return window.location.protocol + '//cad-api.' + domain + '/api/v1/'
    }
  } else {
    return process.env.VUE_APP_API_URL
  }
}
const FilesBase = () => {
  let domain = window.location.hostname
  let indexOfDomainStart = domain.indexOf('.')
  if (domain !== 'localhost') {
    if (domain.split('.').length == 3) {
      return (
        window.location.protocol +
        '//files' +
        domain.substring(indexOfDomainStart) +
        '/api/v1/'
      )
    }
    if (domain.split('.').length == 2) {
      return window.location.protocol + '//files.' + domain + '/api/v1/'
    }
  } else {
    return process.env.VUE_APP_FILES_URL
  }
}

export default {
  Applications: {
    GetAll: ApiBase() + 'applications',
  },
  Auth: {
    Logon: AuthBase() + 'auth/logon',
    RefreshLogon: AuthBase() + 'auth/refresh-logon',
    Logoff: AuthBase() + 'auth/logoff',
    ChangePassword: AuthBase() + 'users/',
  },
  User: {
    GetOne: ApiBase() + 'users/',
    Tenants: BaseV2() + 'tenants',
  },
  Files: {
    Logo: FilesBase() + 'logos',
  },
}
